import React from 'react';
import { motion } from 'framer-motion';

interface KpiCardProps {
  title: string;
  value: number | string;
  subtitle?: string; // ADICIONEI ESTA PROP
  icon?: React.ReactNode;
  unit?: string;
  valueColorClass?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  subtitle, // NOVA PROP
  icon,
  unit,
  valueColorClass = 'text-primary',
}) => {
  return (
    <motion.div
      className="relative flex flex-col items-start justify-between p-6 bg-background rounded-lg shadow-xl overflow-hidden
                 border border-primary/20 hover:border-primary/50 transition-all duration-300 ease-in-out
                 transform hover:-translate-y-1 hover:shadow-2xl cursor-pointer min-w-[250px]"
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
      aria-label={`KPI: ${title} com valor ${value} ${unit || ''}`}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background to-background/80 opacity-90 rounded-lg"></div>

      <div className="relative z-10 flex items-center justify-between w-full mb-4">
        {icon && (
          <div className="p-3 rounded-full bg-gradient-to-r from-[#c5a663] via-[#f2dd82] to-[#c5a663]/10 text-secondary flex items-center justify-center text-2xl mr-4">
            {icon}
          </div>
        )}
        <h3 className="text-lg font-semibold text-text leading-tight flex-grow">
          {title}
        </h3>
      </div>

      {/* Seção do valor e unidade */}
      <div className="relative z-10 flex items-baseline w-full mb-2">
        <p className={`text-4xl font-extrabold ${valueColorClass} leading-none`}>
          {value}
        </p>
        {unit && (
          <span className="ml-2 text-xl font-medium text-text/70">
            {unit}
          </span>
        )}
      </div>

      {/* SUBTITLE ADICIONADO AQUI */}
      {subtitle && (
        <div className="relative z-10 w-full">
          <p className="text-sm text-text/60 font-medium">
            {subtitle}
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default KpiCard;